(function (app) {

    app.factory("featureToggleService", ["$location",
        function featureToggleService ($location) {
            var service = {};

            service.checkEnv = checkEnv;

            return service;

            function checkEnv() {
                var url = $location.absUrl();

                if (url.includes('portal.figmarketing.com')) {
                    return 'prod';
                } else if (url.includes('beta.agentportal.figdevteam.com')) {
                    return 'beta';
                } else if (url.includes('qa.agentportal.figdevteam.com')) {
                    return 'qa';
                } else {
                    return 'local';
                }
            }
        }

    ]);

})(window.app); //jshint ignore:line